import { List, Map } from 'immutable';

import { types as managementTypes } from './../../ducks/team-management';
import { types as teamsTypes } from './../../ducks/teams';

const initialState = new Map({
  loading: true,
  autocompletedTeams: new List(),
});

const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case managementTypes.INITIAL_USER_TABLE.SUCCESS:
      return state.set('loading', false);
    case teamsTypes.AUTOCOMPLETE_TEAMS_GET.SUCCESS:
      return state.set('autocompletedTeams', new List(payload.results));
    default:
      return state;
  }
};

export default usersReducer;
